import { UIText2 } from '@cian/ui-kit';

import * as styles from './DobroFormText.css';

export interface IDobroFormTextProps {
  children: React.ReactNode;
}

export function DobroFormText(props: IDobroFormTextProps) {
  return (
    <div className={styles.text}>
      <UIText2 color="gray60_100">{props.children}</UIText2>
    </div>
  );
}
